export default {
  schedules: [],
  pagination: {},
  schedule: {}
}
